import React from 'react';
import {
  GlobalSearchProvider,
  GlobalSearchResultsPage,
  HeaderSearch as FeatureHeaderSearch,
} from '@hopdrive/feature-global-search';
import { dealerSearchConfig } from './searchConfig';

/**
 * The dealer portal's global search mount points.
 *
 * Both are the feature's components wrapped in the portal's config (#1237) —
 * the entities, queries, ranking and results page all live in
 * `features/global-search`. This portal's own contribution is
 * ./searchConfig.tsx. Results are scoped to the user's rooftops by the
 * dealer-role Hasura filters.
 */

/** Full results for /search?q=… */
export const GlobalSearchPage: React.FC = () => (
  <GlobalSearchProvider config={dealerSearchConfig}>
    <GlobalSearchResultsPage />
  </GlobalSearchProvider>
);

/** The header's submit-only search bar. */
export const HeaderSearch: React.FC = () => (
  <GlobalSearchProvider config={dealerSearchConfig}>
    <FeatureHeaderSearch inputName='global-search' />
  </GlobalSearchProvider>
);

export { dealerSearchConfig } from './searchConfig';
